/**
 * Tag API service for ATS.
 */

import { createApiClient } from '@aaas/shared';

export interface ATSTag {
  id: string;
  name: string;
  slug: string;
}

interface TagListApiResponse {
  success: boolean;
  data: ATSTag[];
  message: string;
}

class TagService {
  async listTags(
    workspaceId: string,
    idToken: string,
    options: { search?: string; limit?: number } = {}
  ): Promise<TagListApiResponse> {
    const { search, limit = 10 } = options;
    const client = createApiClient(idToken, 'ats');
    const response = await client.get<TagListApiResponse>('/tags', {
      params: {
        limit,
        ...(search && { search }),
      },
      headers: { 'X-Workspace-ID': workspaceId },
    });

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to list tags');
    }

    return response.data;
  }
}

export default new TagService();
